module.exports = __webpack_public_path__ + "img/d5.79c26d51.png";